import type { GiftlyDesign } from '@consumer/types/serializers'

/**
 * Determines if a design is a holiday design.
 * Matches the Ruby logic in app/values/giftly_designs.rb#holidays?
 */
export function isHolidayDesign (design: GiftlyDesign): boolean {
  const id = design.id
  const santa = id.includes('v3-holidays-2024-1')
  return id.includes('holidays') && !santa && !id.includes('gcip')
}
